<template>
    <div class="conainer" style="margin-top:70px">
        <div v-if="company">
            <profile-company-partials :company="company" @action="actionProfile" @visual="visualImg"/>
            <div v-if="tabs[1].active||activeCoupon"  style="margin-top:70px"  class="J-card-body">
                <component-coupons-list :dataCoupons="dataCoupons" @action="actionCoupons" :company="null"  @visual="visualImg"/>
            </div>
            <div  v-if="tabs[0].active">
                <div v-if="app_catalog=='color'">
                    <color-catalog-public :view="false" @viewImage="visualImg" :dataservices="arraydataservices" @action="actionCatalog"/>
                </div>
                <div class="J-card-body m-b" v-else>
                    <div class="J-card-item" v-for="(arraydataservice,index) in arraydataservices" :key="index+1">
                        <carousel :autoplay="true" :nav="false" :autoplayTimeout="10000" :responsive="{0:{items:1,nav:false},600:{items:1,nav:false}}" :autoplayHoverPause="true">
                            <template slot="prev"><button type="button" class="J-controls-carusel prev"><i class="fas fa-angle-left"></i></button></template>
                            <div v-for="(item,i) in arraydataservice.items" :key="i+1" >
                                <div class="J-card-item-content">
                                    <div class="J-circle-image">
                                        
                                         <div class="J-circle-image-url" v-if="item.images&&item.images.length>0">
                                            <img :src="item.images[0].link" style="cursor:pointer" >
                                        </div>
                                        <div class="J-circle-image-url" v-else-if="arraydataservice.image">
                                            <img :src="arraydataservice.image[0].link" style="cursor:pointer" >
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="J-content-price">
                                        S/. {{item.price}}
                                    </div>
                                </div>
                                <div>
                                    <h5 v-if="arraydataservice.typeservices">{{`${arraydataservice.typeservices} de ${arraydataservice.name}`}}</h5>
                                    <div v-else class="J-content-title">{{ `${arraydataservice.name}`}}</div>
                                </div>
                                <div class="J-list-status">
                                    
                                </div>
                                <div class="J-content-description"> {{item.description}}</div>

                                <hr>
                                <div class="J-list-price-item">
                                    <div class="J-list-price-minus">
                                        <button class="J-card-item-btn" @click="amountUnique(-1,index,i)"><i class="fas fa-minus"></i></button>
                                    </div>
                                    
                                    <div class="J-list-price-content">
                                        <span v-if="i==0">
                                            <i class="" v-if="item.checked===undefined">{{$set(item, 'checked', true)}}</i>
                                            <i class="" v-else-if="item.checked==true"></i>
                                        </span>
                                        <span v-else>
                                            <i class="" v-if="item.checked===undefined"></i>
                                            <i class="" v-else-if="item.checked==true"></i>
                                        </span>
                                        
                                        <!-- <div class="J-content-price">S/. {{item.price}} </div><div class="J-content-description"> {{item.description}}</div>
                                        <span class="J-color-product" :style="'background-color:'+item.color">
                                            
                                        </span> -->
                                        <div>
                                            <div class="J-card-item--amount" v-if="item.amount==undefined">{{$set(item, 'amount', 0)}}</div>
                                            <div class="J-card-item--amount" v-else-if="item.amount!==0">{{item.amount}}</div> 
                                        </div>
                                    </div>
                                    <div class="J-list-price-plus">
                                        <button class="J-card-item-btn" @click="amountUnique(+1,index,i)"><i class="fas fa-plus"></i></button>
                                    </div>
                                    
                                </div>
                            </div>
                            <template v-if="arraydataservice.items.length>1" slot="next"><button type="button" class="J-controls-carusel next"><i class="fas fa-angle-right"></i></button></template>
                        </carousel>
                    </div>
                </div>
            </div>
            <div v-if="tabs[2].active"   style="margin-top:70px"  class="J-card-body">
                <component-info-company-list :id_company="id_company"  @visual="visualImg"/>
            </div>
        </div>
        <div v-else style="text-align:center">
            Pagina no encontrada
        </div>
        <button class="J-btn-float J-btn-float-primary J-btn-lg-cart" style="z-index: 1;" @click="viewCart()">
            Comprar <span class="ml-3"><i class="fas fa-shopping-cart"></i></span>
        </button>
        <image-visual-partials :url="imgVisual" ref="visual"/>
    </div>
</template>
<script>
import { EventBus } from '@/helpers/eventbus/event-bus'
import {CartStorage,SearchListStorage,CouponStorage,CompanyStorage} from '@/helpers/storage'
const alertify = require('alertifyjs')
import ImageVisual from "@/components/partials/ImageVisual.partials.vue"
import {CouponsService} from '@/services'

import ProfileCompany from "@/components/partials/ProfileCompany.partials"
import CatalogPublic from "@/components/apps/color/catalog.public.vue"
import carousel from 'vue-owl-carousel'
import moment from 'moment'

export default {
    data:() => ({
        activeCoupon:false,
        imgVisual:'https://picsum.photos/510/300?random',
        cartStorage:new CartStorage(),
        searchListStorage:new SearchListStorage(),
        companyStorage:new CompanyStorage(),
        couponStorage:new CouponStorage(),
        category:'',
        app_catalog:"",
        moment:moment,
        arraypushservices:[
            {
                id:'0',
                photo:'/img/resources/IconLavar1.png',
                typeservice:'Lavado',
                isregistered: false
            },
            {
                id:'1',
                photo:'/img/resources/IconLavar6.png',
                typeservice:'Gratinado',
                isregistered: false
            },
            {
                id:'2',
                photo:'/img/resources/IconLavar4.png',
                typeservice:'Almidonado',
                isregistered: false
            },
            {
                id:'3',
                photo:'/img/resources/IconLavar7.png',
                typeservice:'Planchado',
                isregistered: false
            },
            {
                id:'4',
                photo:'/img/resources/IconLavar3.png',
                typeservice:'Teñido',
                isregistered: false
            },
            {
                id:'5',
                photo:'/img/resources/IconLavar5.png',
                typeservice:'Secado',
                isregistered: false
            }
        ],
        arraydataservices:[
        ],
        name:'n',
        id_company:null,
        search:{
            type:"Lavado"
        },
        search:{
            name:''
        },
        tabs:[
            {
                title:"Productos",
                active:true,
            },
            {
                title:"Cupones",
                active:false,
            },
            {
                title:"Acerca",
                active:false,
            }
        ],
        company:null,
        datacart:[],
        dataCoupons:[],
        isSearch:false,
    }),
    async created(){
        this.checkeLogin()
        this.id_company=this.$route.params.id_company;
        this.search.name=this.$route.params.name;
        if(this.id_company!=undefined){
            await this.getListSerivicesAll();
            this.searchCoupons();

        }
        else{
            document.title =this.search.name;
            await this.getNameCompany();
        }
        
    
    },
    async mounted(){
        
    },
    methods:{
        couponApply:function(){
            var couponStr=this.couponStorage.get()

            if(couponStr.key){
                var company=this.companyStorage.get();

                var query={
                    coupon:couponStr.key,
                    date:moment().format("YYYY-MM-DD HH:mm:ss"),
                    id_company:company.id_company,
                }

                CouponsService.apply(query).then(res=>{
                    var {data}=res.data;
                    this.coupons=data;

                    if(couponStr){
                        var {key,company}=couponStr;
                    }
                    else{
                       var coupon=query.coupon;
                       var company=query.id_company;
                    }
                    var data_coupon={
                        coupon:key,
                        ...data,
                        _id:data._id,
                        apply:true,
                        company:company,
                    };
                    this.couponStorage.set(data_coupon);
                    alertify.success('Cupón aplicado');

                })
                .catch(err=>{
                    alertify.error('Cupón no valido');
                })
            }
        },
        actionCoupons(data){
            this.couponStorage.set({
                company: this.id_company,
                ...data
            })
            this.couponApply()
            this.checkedCoupon()
        },
        actionCatalog(type,data){
            this.amountUnique(data.sum,data.index,data.i)
        },
        visualImg(url){
            this.$refs.visual.isOpen();
            this.imgVisual=url
        },
        async getNameCompany(){
             await axios.get(`name?q=${this.search.name}`)
            .then(async(res)=>{
                const {data}=res.data
                this.id_company=data._id
                this.isSearch=true;
                await this.getListSerivicesAll();
                this.searchCoupons();
            })
            .catch(err=>{
                
            });
        },
        actionProfile(e){
            this.tabs=e
        },
        searchCoupons(){
            var company=this.companyStorage.get();
            var query={
                id_company:company.id_company,
                id_office:company.id_office,
            }

            CouponsService.listPublic(query)
            .then(res=>{
                var {data}=res.data;
                this.dataCoupons=data;
               
                this.checkedCoupon()
                
            })
            .catch(err=>{
                this.dataCoupons=[]
                console.log(err)
            })
            if(this.session) this.getPrivateCoupons(query)
        },
        getPrivateCoupons(query){
            CouponsService.listPrivate(query)
            .then(res=>{
                var {data}=res.data;
                this.dataCoupons=[...this.dataCoupons,...data]
                this.activeCoupon=true;
                this.checkedCoupon()

            })
            .catch(err=>{
                console.log(err)
            })
        },
        checkedCoupon(){
            try{
                var storageCoupon=this.couponStorage.get();
                var index=this.dataCoupons.findIndex(el=>el.key==storageCoupon.key)
                if(index!=-1){
                    this.dataCoupons=[this.dataCoupons[index]]
                    console.log(this.dataCoupons)
                    var products=[]
                    this.arraydataservices.forEach(el=>{
                        var items=[]
                        if(this.dataCoupons[0].products.length==0) throw "product not locations";
                        this.dataCoupons[0].products.forEach(e=>{
                            var i=el.items.findIndex(ele=>ele._id==e._id)
                            if(i!=-1){
                                items.push(el.items[i])
                            
                            }
                        })
                        if(items.length>0){
                            el.items=items
                            products.push(el)
                        }
                    })
                    this.arraydataservices=products
                }
            }
            catch($e){
                console.log($e)
            }

        },
        checkedAmount(id,amount){
            try{
                var data=this.dataCoupons[0].products.find(el=>el._id==id)
                if(amount<=data.amount){
                    return true;
                }
                return false;
            }
            catch($e){
                console.log($e)
                return true;
            }
        },
        checkedSearch(){
            var search=this.searchListStorage.get()||null;
            if(search){
                var data=[]
                search.forEach((el)=>{
                    var index=this.arraydataservices.findIndex((e)=>e._id==el._id);
                    if(index!=-1){
                        data.push(
                            this.arraydataservices[index]
                        );
                    }
                })
                this.arraydataservices=data.length==0? this.arraydataservices:data;
            }
        },
        checkedItem:function(index,i=0,item= null){
            this.arraydataservices[index].items.forEach(element=>{
                this.$set(element,'checked',false);
            })
            this.$set(item,'checked',true);
        },
        changeDistinctSelect:function(index){
            var services=this.arraydataservices[index];
            var find=services.items.findIndex((e)=>e.checked==true);
            var lengthS=services.items.length-1;
            if(find<=lengthS){
                var count=0;
                var bandera=false;
                services.items.forEach((e)=>{
                    if(e.amount>0){
                        if(bandera==false){
                           this.$set(e,'checked',true); 
                           bandera=true;
                        }
                    }
                    else{
                        count++;
                        this.$set(e,'checked',false);
                    }
                });
                if((count-1)==lengthS){
                    this.$set(services.items[0],'checked',true); 
                }
            }
            
        },
        changeDataCart:function(){
            var dataJsonCart=JSON.parse(localStorage.getItem('cart'))||[];

            dataJsonCart.forEach(element => {
                var findcart=this.arraydataservices.findIndex((e)=>e._id===element._id);
                if(findcart!=-1){
                    this.$set(this.arraydataservices[findcart],'amount',element.amount)
                    element.items.forEach((e,i)=>{
                        this.$set(this.arraydataservices[findcart].items[i],'amount',e.amount)
                        if(e.sizes){
                            this.$set(this.arraydataservices[findcart].items[i],'sizes',e.sizes)
                        }
                    })
                }
            });
            this.datacart=dataJsonCart;
        },
        checkVisble:function(index){
            //this.$set(this.arraydataservices[index], 'visible', true)
        },
        amountUnique: async function(sum,index,i){

            var result=this.arraydataservices[index].amount+sum;
            var result2=this.arraydataservices[index].items[i].amount+sum;
            
            var validPro=this.checkedAmount(this.arraydataservices[index].items[i]._id,result2)
            if(!validPro){
                return;
            }
            if(result2<0){

                await this.addAmountItem(index,sum,i);
                if(result<=0) {
                    console.log(result)
                    this.$set(this.arraydataservices[index],'amount',0)
                    this.addcart(this.arraydataservices[index],true);
                    return;
                }
                this.addcart(this.arraydataservices[index]);
                this.$set(this.arraydataservices[index],'amount',result)
                return;
            }
            await this.addAmountItem(index,sum,i);
            this.$set(this.arraydataservices[index],'amount',result)
            this.addcart(this.arraydataservices[index]);
        },
        amount:function(sum,index){
            var result=this.arraydataservices[index].amount+sum;
            if(result<=0){
                this.addAmountItem(index,sum);
                this.$set(this.arraydataservices[index],'amount',0)
                this.addcart(this.arraydataservices[index],true);
                return;
            }
            this.addAmountItem(index,sum);
            this.$set(this.arraydataservices[index],'amount',result)
            this.addcart(this.arraydataservices[index]);
        },
        addAmountItem:function(i,sum,index=-1){
            var find=index==-1?this.arraydataservices[i].items.findIndex((e)=>e.checked==true):index;
            if(find!=-1){

                var amount=this.arraydataservices[i].items[find].amount==undefined?0:this.arraydataservices[i].items[find].amount;
                var total=sum+amount;
                if(total<=0){
                    this.$set(this.arraydataservices[i].items[find],'amount',0);
                    this.changeDistinctSelect(i);
                    return;
                }
                this.$set(this.arraydataservices[i].items[find],'amount',total)
            }
        },
        addcart:function(data,splice=false){

            var findcart=this.datacart.findIndex((element)=>element._id===data._id)
            data.visible=0;
            if(findcart!=-1){
                if(splice==true){
                    this.datacart.splice(findcart,1)
                }
                else{
                    this.datacart[findcart].amount=data.amount;
                    this.datacart[findcart].items=data.items;
                }
            }
            else{
                if(splice==false) this.datacart.push(data);
            }
            localStorage.setItem('cart',JSON.stringify(this.datacart));
        },
        checkeLogin(){
            this.session = JSON.parse(localStorage.getItem('iden'))
            console.log(this.session)
        },
        viewCart:function(){
            var cart=this.cartStorage.get()
            if(!this.session){
                EventBus.$emit('goLogin')
            }
            else if(cart==null){
                this.$set(this.arraydataservices[this.arraydataservices.length-1],'visible',true);
                alertify.error("Agrege un producto")
            }
            else if(cart.length==0){
                this.$set(this.arraydataservices[this.arraydataservices.length-1],'visible',true);
                alertify.error("Agrege un producto")
            }
            else{
                if(this.category=='proveedor'){
                    if(this.company.managers_primary){
                        var user= JSON.parse(localStorage.getItem('iden'))
                        if(user){
                            if(user._id==this.company.managers_primary._iduser){
                                this.$router.push('/cart');
                            }
                        }
                    }
                   else{
                        alertify.error("Tienes que ser vendedor para poder realizar tu pedido contacte con su proveedor y pase sus datos requeridos")
                   }
                }
                else{
                    this.$router.push('/cart');
                }
            }
        },
        checkSearch:function(type){
            this.search.type=type
            this.getListSerivices();
        },
        addMeta(){
            this.meta(true,'og:title',this.company.name);
            this.meta(true,'og:url',window.location);
            this.meta(true,'og:description',this.company.description?this.company.description:`Gootwork negocios - Puedes registrar cualquier negocio, si tienes un negocio no esperes mas, regístrese es totalmente gratis al igual que ${this.company.name} lo hizo`);
            this.meta(true,'og:image',this.company.image_company.link);

            this.meta(false,'title',this.company.name);
            this.meta(false,'url',window.location);
            this.meta(false,'image',this.company.image_company.link);
            this.meta(false,'description',this.company.description?this.company.description:`Gootwork negocios - Puedes registrar cualquier negocio, si tienes un negocio no esperes mas, regístrese es totalmente gratis al igual que ${this.company.name} lo hizo`);
        },
        getListSerivicesAll:async function(){
            await axios.get(`service/list/${this.id_company}?q=`)
            .then(res=>{
                const {data}=res.data
                this.arraydataservices=data==null?[]:data.service.reverse();
                this.category=data==null?'':data.category;
                if(this.isSearch){
                    this.companyStorage.set({
                        category: this.category,
                        id_company: this.id_company,
                        id_office: data.office[0]._id,
                        latitude:  data.office[0].location[1],
                        longitude:  data.office[0].location[0],
                        name_company:  data.name,
                        name_sede:  data.office[0].name,
                    });
                }
                var company=this.companyStorage.get();
               
                this.company={
                    '_id':data._id,
                    'category':data.category,
                    'image_company':data.image_company,
                    'description':data.description,
                    'name':data.name,
                    'managers_primary':data.managers_primary,
                    'office':data.office.find((e)=>e._id==company.id_office),
                }
                this.catalogSelected(data.apps)
                this.addMeta();
                this.changeDataCart();
                this.checkedSearch();
                this.orderPrice();
            })
            .catch(err=>{
                
            });
        },
        orderPrice(){
            var quickSort=(array)=>{
                if(array.length<1) return[];
                
                var left=[]
                var right=[]
                var pivot=array[0]
                
                for (let index = 1; index < array.length; index++) {
                    const element = array[index];
                    if(element.price<pivot.price){
                        left.push(element)
                    }
                    else{
                        right.push(element)
                    }
                }
                return [].concat(quickSort(left),pivot,quickSort(right))
            }
            this.arraydataservices.forEach(el=>{
                el.items=quickSort(el.items)
                el.price=el.items[0].price;
            })

            this.arraydataservices=quickSort(this.arraydataservices)
        },
        getListSerivices:async function(){
            var q=this.search.type;
            await axios.get(`service/list/${this.id_company}?q=${q}`)
            .then(res=>{
                const {data}=res.data
                this.arraydataservices=data==null?[]:data.service;
                this.category=data==null?'':data.category;

                this.catalogSelected(data.apps)
                this.changeDataCart();
            })
            .catch(err=>{
                
            });
        },
        catalogSelected(apps){
            var catalog=apps?apps.find((el)=>el.category=="catalog"):"";
            this.app_catalog=catalog.name
            var company=this.companyStorage.get();
            company.app_catalog=this.app_catalog;
            this.companyStorage.set(company)
            this.changeDataCart();
        }
    },
    watch: {
        '$route': function (refreshPage) {

            var newEmpresa = refreshPage.params.name;
            this.id_company=refreshPage.params.id_company;
            this.checkeLogin()
            //console.log('buscando',newEmpresa);
            if(newEmpresa){
                this.search.name=newEmpresa;
                this.isVisible=false;
                this.getNameCompany();
            }
            else if(id_company){
                this.getListSerivicesAll();
                this.searchCoupons();
            }
            // this.$store.dispatch('searchingUser', newUser);
        }
    },
    components: {
        'image-visual-partials':ImageVisual,
        'color-catalog-public':CatalogPublic,
        'profile-company-partials':ProfileCompany,
        "component-coupons-list":()=>import("@/components/partials/CuponesList.partials"),
        "component-info-company-list":()=>import("@/components/Templates/modulos/Empresa/ProfileOfCompanies"),
        carousel
    },
}
</script>